<template>
    <!-- TODO: fix these heights and widths -->
    <div>
    <l-map style="height: 50vh" :zoom="zoom" :center="center">
      <l-tile-layer :url="url"></l-tile-layer>
      <l-rectangle
        v-for="rectangle in this.rectangles"
        :key="rectangle.name"
        :name="rectangle.name"
        :bounds="rectangle.bounds"
        :color="rectangle.style.color"
        :weight="rectangle.style.weight"
        :dashOffset="rectangle.style.dashOffset"
        :dashArray="rectangle.style.dashArray"
        :fill="rectangle.style.fill"
      >
      </l-rectangle>
    </l-map>
    </div>
</template>

<script>
import { LMap, LTileLayer, LRectangle } from "vue2-leaflet";
import "leaflet/dist/leaflet.css"; // need to import the css so that it is bounded

export default {
  name: "BoundingBoxRepresentation",
  components: {
    LMap,
    LTileLayer,
    LRectangle,
  },
  props: {
    content: {
      type: String,
      default: "{}",
    },
  },
  data: () => ({
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    // Reference for the map; but clients do not need to see this.
    // attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  }),
  computed: {
    objContent() {
      return JSON.parse(this.content);
    },
    rectangles() {
      const main = this.objContent["head"];
      main["style"] = {
        color: "blue",
        weight: 3,
        fill: false,
      };
      const rectangles = Array(main);
      if (this.objContent.distributions) {
        for (let key in Object.keys(this.objContent.distributions)) {
          const distribution = this.objContent.distributions[key];
          distribution["style"] = {
            color: "green",
            weight: 2,
            fill: false,
            dashArray: "10, 10",
            dashOffset: "10",
          };
          rectangles.push(distribution);
        }
      }
      return rectangles;
    },
    center() {
      return this.objContent.center;
    },
    zoom() {
      return this.objContent.zoom;
    }
  },
};
</script>
